export default __webpack_public_path__ + "static/banner-new-zealand-33e286fb1ca13a3e3571311e8315b863.jpg";